import { memo } from "react";
import { Typography, Grid2 } from "@mui/material";
import Popup from "../Popup.js";
import { SecondaryBorderButton, SecondaryBackgroundButton } from "../Buttons.js";

const InformPopup = ({
    width = "700px",
    isOpen,
    title,
    titleColor = "black",
    onClose,
    innerText = [], // Expecting an array of messages
    buttonText = "",
    onClick,
    onAccept,
    acceptText,
    cancelable = true
}) => {
    return (
        <Popup
            width={width}
            open={isOpen}
            title={title}
            titleColor={titleColor}
            onClose={onClose}
        >
            {innerText.length > 1 ? (
                <Typography sx={{ color: "dark.main", marginTop: "-1rem", marginBottom: "1rem" }}>
                    <ul style={{ paddingLeft: "1.5rem", margin: "0" }}>
                        {innerText.map((text, index) => (
                            <li key={index} style={{ marginBottom: "0.5rem" }}>
                                {text}
                            </li>
                        ))}
                    </ul>
                </Typography>
            ) :
                <>
                    <Typography sx={{ color: "dark.main", marginTop: "-1rem", marginBottom: "1rem" }}>
                        {innerText}
                    </Typography>
                </>
            }
            <Grid2
                width="100%"
                px={4}
                py={2}
                sx={{
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    fontSize: "1rem",
                    justifyContent: "flex-end",
                    display: "flex",
                    marginLeft: "auto",
                    marginBottom: "-2rem",
                }}
            >
                {cancelable && (
                    <SecondaryBorderButton title={buttonText} backgroundColor="transparent" onClick={onClick} />
                )}
                {onAccept && (
                    <>
                        <div style={{ width: "30px" }} />
                        <SecondaryBackgroundButton title={acceptText} width={"300px"} onClick={onAccept} />
                    </>
                )}
            </Grid2>
        </Popup>
    );
};

export default memo(InformPopup);
